import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { Response } from '@angular/http';

import { Device } from './device.model';
import { DeviceService } from './device.service';
import { Seller, SellerService } from '../seller';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

@Component( {
    selector: 'dcs-device-import',
    templateUrl: './device-import.component.html'
} )
export class DeviceImportComponent implements OnInit {
    authorities: any[];
    isSaving: boolean;
    sellers: Seller[];
    show = {
        danger: true,
        warning: true,
        info: true,
        success: true
    };
    devices = {
        sn: '',
        seller: null,
        force: false
    };

    reports: any[];
    type: string;

    constructor(private jhiLanguageService: JhiLanguageService,
                private router: Router,
                private alertService: AlertService,
                private deviceService: DeviceService,
                private sellerService: SellerService,
                private eventManager: EventManager,
                private route: ActivatedRoute) {
        this.jhiLanguageService.setLocations( [ 'device' ] );

    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = [ 'ROLE_ADMIN' ];
        this.sellerService.query( {
            page: 0,
            size: 99999,
            sort: [ 'name,' + 'asc','id' ]
        } ).subscribe(
            (res: Response) => {
                this.sellers = res.json();
                console.log( this.sellers );
            }, (res: Response) => this.onError( res.json() ) );

        this.type = this.route.snapshot.data[ 'type' ];
    }

    save() {
        console.log( this.devices )
        if(confirm('Are you sure?')){
            this.isSaving = true;
            if (this.type === 'import') {
                this.deviceService.addMany( this.devices )
                    .subscribe( (res: any) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );
            } else if (this.type === 'delete') {
                this.deviceService.deleteMany( this.devices )
                    .subscribe( (res: any) => this.onSaveSuccess( res ), (res: Response) => this.onSaveError( res.json() ) );

            }
        }

    }

    private onSaveSuccess(result: any) {
        this.isSaving = false;
        console.log( result )
        if (result.length > 0) {
            this.reports = result;
        } else {
            this.eventManager.broadcast( { name: 'deviceListModification', content: 'OK' } );
            this.isSaving = false;
            this.clear();

        }
    }

    clear() {
        this.router.navigate( [ '/device' ] );
    }

    canShowStatus(status: string): boolean {

        return true;
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError( error );
    }

    private onError(error) {
        this.alertService.error( error.message, null, null );
    }

    trackSellerById(index: number, item: Seller) {
        return item.id;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/device/device-import.component.ts